'use strict';

export default function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      type: 'column',
      height: 250,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {
      text: '曜日毎の平均消費電力',
      style: { fontSize: '14px' }
    },
    legend: {enabled: false},
    xAxis: {
      categories: scope.WEEK,
      crosshair: true,
      labels: {
        formatter: function () {
          let style = '';
          let day = this.value;
          if(day === '日') {
            style = 'color: #ff3131';
          } else if(day === '土') {
            style = 'color: #3737ff';
          }

          return `<span style="${style}">${day}</span>`;
        }
      },
      max: 6
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '平均消費電力 [kWh]',
        style: {'font-size': '13px'}
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function () {
        let tip_format = "<tspan style='font-size: 12px'>" + this.x + "曜日</tspan>";

        let point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
        tip_format += point.y + " kWh";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: {
      column: {grouping: false}
    },
    series: [
      {
        name: '平均消費電力'
      }
    ]
  };
}



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/power-stat-graph/active-power/power-stat-graph-active.config.js